import { render, staticRenderFns } from "./AddOnChargeTable.vue?vue&type=template&id=1df69d58&scoped=true&"
import script from "./AddOnChargeTable.vue?vue&type=script&lang=js&"
export * from "./AddOnChargeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df69d58",
  null
  
)

export default component.exports